import { render, staticRenderFns } from "./ProductActualStock.vue?vue&type=template&id=aefcf6f8"
import script from "./ProductActualStock.vue?vue&type=script&lang=ts"
export * from "./ProductActualStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aefcf6f8')) {
      api.createRecord('aefcf6f8', component.options)
    } else {
      api.reload('aefcf6f8', component.options)
    }
    module.hot.accept("./ProductActualStock.vue?vue&type=template&id=aefcf6f8", function () {
      api.rerender('aefcf6f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductActualStock.vue"
export default component.exports